import React from "react";

const FaqIcon = ({width=15,height=15}) => {
  return (
    <svg width={width} height={height} cursor="pointer" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 5.625H10.125M9 7.875H10.125M4.5 10.125H10.125M4.5 12.375H10.125M12.375 5.625H14.9062C15.372 5.625 15.75 6.003 15.75 6.46875V13.5C15.75 13.9476 15.5722 14.3768 15.2557 14.6932C14.9393 15.0097 14.5101 15.1875 14.0625 15.1875M12.375 5.625V13.5C12.375 13.9476 12.5528 14.3768 12.8693 14.6932C13.1857 15.0097 13.6149 15.1875 14.0625 15.1875M12.375 5.625V3.65625C12.375 3.1905 11.997 2.8125 11.5312 2.8125H3.09375C2.628 2.8125 2.25 3.1905 2.25 3.65625V13.5C2.25 13.9476 2.42779 14.3768 2.74426 14.6932C3.06072 15.0097 3.48995 15.1875 3.9375 15.1875H14.0625M4.5 5.625H6.75V7.875H4.5V5.625Z" stroke="#5C91FF" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    
  );
};

export default FaqIcon;
